<template>
    <div class="hero__content">
        <div class="hero__text">
            <p class="member_disclaimer">Aanbod enkel geldig voor nieuwe leden</p>
            <p class="offer_text">Ontdek Testaankoop  2 maanden <br>lang voor € 2 en</p>
            <img class="box_up" :src="box_up_image" alt="gifts">
            <p class="gift_text nl">kies je <strong>gratis </strong>cadeau</p>
            <div class="offer_pastille">aanbod <p class="price">€2</p> <p class="time">/2 maanden</p></div>
            <img class="box_gifts" :src="box_down_image" alt="gifts">
        </div>
        <slot></slot>
    </div>
</template>

<script>
import image_mixin from "../../_commons/fr/mixins/image_mixin";

export default {
    name: "HomeHeroMobile",
    mixins: [
        image_mixin
    ]
}
</script>
